"use client";

import { scrollToTop } from "@homeinstead/shared";
import Logo from "~care/components/ui/Icons/ui/Logo/Logo";

const NavigationLogoButton = () => (
  <button
    onClick={(e) => {
      e.preventDefault();
      scrollToTop();
    }}
    style={{ overflow: "visible" }}
    title="Home Instead"
  >
    <Logo className="h-10 w-[123px] fill-friendly-base sm:h-12 sm:w-[148px]" />
  </button>
);

export default NavigationLogoButton;
